<div class="games-menu__popup">
    <div class="games-popup">
        <button class="games-popup__close-btn close-btn"
                (click)="onCloseTabs()">
            <img src="../../../assets/images/games-playground/close-btn.png"
                 title="Close"
                 alt="Close">
        </button>

        <div [hidden]="isHelpStep"
             *ngIf="!registrationPartActive">
            <div class="games-popup__text" *ngIf="isPhoneClassActive()">
                Enter your phone number, and click Next.
            </div>
            <div class="games-popup__text" *ngIf="isPinClassActive() && !(isSecondStepAuthAuthPinPassword() || isSecondStepAuthSMSPinPassword() || isSecondStepPassword())">
                Enter your PIN number, and click Next.
            </div>
            <div class="games-popup__text" *ngIf="isSecondStepPassword() || isSecondStepAuthAuthPinPassword() || isSecondStepAuthSMSPinPassword()">
                Enter your PASSWORD, and click Next.
            </div>
        </div>

        <div [hidden]="!isHelpStep">
            <div class="games-popup__text"
                 *ngIf="isHelpStep === 1">
                If you forgot both your PIN and your PASSWORD, then reset the PASSWORD.
            </div>
            <div class="games-popup__text"
                 *ngIf="isHelpStep === 2">
                Enter the confirmation CODE that was both texted and emailed to you.
            </div>
            <div class="games-popup__text"
                 *ngIf="isHelpStep === 3">
                Create your password
            </div>
        </div>

        <div *ngIf="registrationPartActive">
            <div class="games-popup__text"
                 *ngIf="registrationPartStep === 1">
                Create your password
            </div>

            <div class="games-popup__text"
                 *ngIf="registrationPartStep === 2">
                Create your PIN
            </div>
            <div class="games-popup__text"
                 *ngIf="registrationPartStep === 3">
                Enter your name <span *ngIf="!isRegistrationUpdate">and PROMO CODE if you have it</span>
            </div>
        </div>

        <div *ngIf="isHelpStep === 1"
             style="margin: -.1696em auto; text-align: center"
             class="text t-light login-text login__resend">
            {{phoneForm.controls.phone.value | mask: phoneMask}}
        </div>


        <form  [formGroup]="phoneForm"
               *ngIf="isPhoneClassActive()">
            <div>
                <input formControlName="phone"
                       [mask]="phoneMask"
                       thousandSeparator=","
                       placeholder="PHONE"
                       [type]="'tel'"
                       autocomplete="off"
                       class="games-popup__input">
            </div>
            <div class="games-popup__row games-popup__row--center" style="margin-top: 1em">
                <button class="games-btn"
                        (click)="onPhoneSubmit()"
                        [disabled]="isLoginBtnDisabled()">
                    <span>Next</span>
                </button>
            </div>
            <div class="games-info">
                <span>Only one phone number can be used per account.</span>
            </div>
        </form>

        <form  *ngIf="isPinClassActive()"
               [formGroup]="pinForm"
               (ngSubmit)="onSubmit()">
            <div class="login__items"
                 formArrayName="digits"
                 [hidden]="isHelpStep === 1 || isHelpStep === 3"
                 *ngIf="isSecondStepAuthAuthPin() || isSecondStepAuthSMSPin() || (registrationPartStep === 2) || (isHelpStep === 2)">
                <input (keydown.enter)="onSubmit()"
                       *ngFor="let field of pinForm.get('digits')['controls']; let i = index" #inputs [maxLength]="1" [formControlName]="i"  (keydown)="check(i, field, $event)"
                       mask="0"
                       class="login-input-small" type="tel">
            </div>

            <ng-container *ngIf="!registrationPartActive">
                <div *ngIf="isSecondStepPassword() || isSecondStepAuthAuthPinPassword() || isSecondStepAuthSMSPinPassword()"
                     class="login__item"
                     [hidden]="isHelpStep">
                    <input formControlName="password"
                           style="margin: 0"
                           placeholder="PASSWORD"
                           [type]="'password'"
                           class="games-popup__input"
                           autocomplete="off">
                </div>

                <div class="games-popup__row games-popup__row--btns"
                     *ngIf="isHelpStep !== 3"
                     style="margin-top: 1em">
                    <button class="games-btn"
                            type="button"
                            [hidden]="!isHelpStep"
                            (click)="onCloseTabs()">
                        <span>Back</span>
                    </button>
                    <button class="games-btn"
                            type="button"
                            [hidden]="isHelpStep"
                            (click)="showHelp()">
                        <span>Help</span>
                    </button>
                    <button class="games-btn"
                            type="button"
                            [hidden]="isHelpStep !== 1"
                            (click)="onForgotPassword()">
                        <span>Reset</span>
                    </button>
                    <button class="games-btn"
                            [hidden]="isHelpStep === 1"
                            [disabled]="isPinLoginBtnDisabled()">
                        <span>Next</span>
                    </button>
                </div>

                <button *ngIf="isSecondStepAuthAuthPinPassword() || isSecondStepAuthAuthPin() || isSecondStepAuthSMSPin() || isSecondStepAuthSMSPinPassword()"
                        [hidden]="isHelpStep"
                        (click)="toggleInputType()"
                        style="margin-bottom: -.5em"
                        type="button" class="text t-light login-text login__resend">
                    <ng-container *ngIf="isSecondStepAuthAuthPin() || isSecondStepAuthSMSPin()">
                        Login with password
                    </ng-container>
                    <ng-container *ngIf="isSecondStepAuthAuthPinPassword() || isSecondStepAuthSMSPinPassword()">
                        Login with pin
                    </ng-container>
                </button>

                <div class="games-info"
                     style="margin-left: -2em; margin-right: -2em">
                    <ng-container *ngIf="!isHelpStep">
                     <span *ngIf="isPinClassActive() && !(isSecondStepAuthAuthPinPassword() || isSecondStepAuthSMSPinPassword() || isSecondStepPassword())">
                        If you forgot your PIN, click login with PASSWORD.
                    </span>
                    <span *ngIf="isPinClassActive() && isSecondStepPassword()">
                        Login with password
                    </span>
                    <span *ngIf="isSecondStepAuthAuthPinPassword() || isSecondStepAuthSMSPinPassword()">
                        If you forgot your PASSWORD, click login with PIN.
                    </span>
                    </ng-container>
                    <ng-container *ngIf="isHelpStep">
                    <span *ngIf="isHelpStep === 1">
                        Reset instructions are sent via a Text Message and Email.
                    </span>
                        <span *ngIf="isHelpStep === 2">
                        Check your spam filters for the message as well.
                    </span>
                    </ng-container>
                </div>
            </ng-container>
        </form>

        <form  [formGroup]="registrationForm"
               *ngIf="isRegistrationClassActive() || (isHelpStep === 3)">
            <div *ngIf="(registrationPartStep === 1) || (isHelpStep === 3)">
                <div class="login__item registration">
                    <input formControlName="password"
                           placeholder="PASSWORD"
                           [type]="'password'"
                           class="games-popup__input"
                           autocomplete="off">
                </div>
                <div class="login__item">
                    <input formControlName="reEnteredPassword"
                           placeholder="RE-ENTER PASSWORD"
                           [type]="'password'"
                           class="games-popup__input"
                           autocomplete="off">
                </div>
            </div>

            <div *ngIf="registrationPartStep === 3">
                <div class="login__item">
                    <input formControlName="firstName"
                           placeholder="FIRST NAME"
                           [type]="'text'"
                           class="games-popup__input"
                           autocomplete="off">
                </div>
                <div class="login__item">
                    <input formControlName="lastName"
                           placeholder="LAST NAME"
                           [type]="'text'"
                           class="games-popup__input"
                           autocomplete="off">
                </div>
                <div class="login__item"
                     *ngIf="!isRegistrationUpdate">
                    <input formControlName="promo"
                           [(ngModel)]="promoCode"
                           placeholder="PROMO CODE"
                           [type]="'text'"
                           class="games-popup__input"
                           autocomplete="off">
                </div>
            </div>
            <div class="games-popup__row games-popup__row--btns"
                 style="margin-top: 1em">
                <button class="games-btn"
                        *ngIf="(registrationPartStep !== 1) || (isHelpStep === 3)"
                        (click)="onRegistrationBackBtnClick()">
                    <span>Back</span>
                </button>
                <button class="games-btn"
                        (click)="onRegistrationNextBtnClick()"
                        [disabled]="isRegistrationNextBtnDisabled()">
                    <span>Next</span>
                </button>
            </div>
            <div class="games-info">
                <span *ngIf="registrationPartStep === 1 || (isHelpStep === 3)">
                    Create a unique PASSWORD
                </span>
                <span *ngIf="registrationPartStep === 2">
                    Create a unique PIN
                </span>
                <span *ngIf="registrationPartStep === 3">
                    Enter your personal info
                </span>
            </div>
        </form>
    </div>
</div>
